import { getCurrentUrl } from '../../../helpers'

/**
 * Whether a menu entry points at the page currently open.
 *
 * The shared `checkIsActive` matches on a bare `current.startsWith(url)`, which
 * also fires for a SIBLING whose alias merely shares a prefix -- `/new-cif-only`
 * would light up while `/new-cif-only-corporate` is open, so two modules could
 * read as selected at once. Requiring a `/` boundary keeps exactly one entry
 * highlighted, while still matching deeper pages of the same module
 * (`/account-closure` stays selected on `/account-closure/form/123`).
 */
export const isMenuActive = (pathname: string, to: string): boolean => {
  if (!pathname || !to) return false
  const current = getCurrentUrl(pathname)
  return current === to || current.startsWith(`${to}/`)
}
